<template>
  <div class="home card">
    <div>
      <div class="text-2xl md:text-4xl text-center mt-16 px-4 md:px-0">
        Your Pets
      </div>
      <NFTList
        @NFTClick="onNFTClick"
        class="cursor-pointer"
        :leaderboard="false"
      />
    </div>
    <div>
      <div class="text-2xl md:text-4xl text-center mt-16 px-4 md:px-0">
        Your NFTs
      </div>
      <MyNfts
        @NFTClick="onNFTClick"
        class="cursor-pointer"
        :leaderboard="false"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NFTList from "@/components/NFTList.vue";
import MyNfts from "@/components/MyNfts.vue";

export default {
  name: "Home",
  components: {
    NFTList,
    MyNfts,
  },
  created: function () {},
  methods: {
    // getNfts: async function () {
    //   const call = `https://api.opensea.io/api/v1/assets?owner=${account}&limit=50&offset=0`;
    //   let nfts = await axios.get(call);
    //   nfts = nfts.data.assets;
    // },
    onNFTClick: function (contract, id) {
      this.$router.push({ name: "vNFT", params: { id: id } });
    },
  },
};
</script>
